<template>
  <AbsPopup id="CreateEpub" title="서지정보" @close="$emit('close')" bodyalign="top" @submit="submit">
    <template #body>
      <div class="popup-body">
        <div class="cover">
          <!-- <img :src="canvasImg" /> -->
          <div>
            <img :src="cover"/>
            <!-- <img src="@/assets/KakaoTalk_20200109_153131671.jpg" /> -->
            <icon class="absMark" :class="[color, position, opacity]" uicon="143"/>
          </div>
          <span>{{ size }}</span>
        </div>
        <div class="info">
          <div>
            <li>
              <div>
                <span>서명(책제목)</span>
              </div>
              <div>
                {{ title }}
              </div>
            </li>
            <li>
              <div>
                <span>저자(필명)</span>
              </div>
              <div>
                {{ name }}
              </div>
            </li>
            <li>
              <div>
                <span>발행일(출간일)</span>
              </div>
              <div>
                {{ timeToDateString(date) }}
              </div>
            </li>
            <li>
              <div>
                <span>발행처</span>
              </div>
              <div>
                {{ publisher }}
              </div>
            </li>
            <li>
              <div>
                <span>전화번호</span>
              </div>
              <div>
                07042528887
              </div>
            </li>
            <li>
              <div>
                <span>주소</span>
              </div>
              <div>
                {{ addr }}
              </div>
            </li>
            <li>
              <div>
                <span>이메일</span>
              </div>
              <div>
                {{ email }}
              </div>
            </li>
            <li>
              <div>
                <span>ISBN</span>
              </div>
              <div>
                <UInput type="text" v-model="isbn"/>
              </div>
            </li>
            <li>
              <div>
                <span>공급자코드</span>
              </div>
              <div>
              </div>
            </li>
            <li>
              <span>저작권자 및 출판사의 서면 동의 없이는 어떠한 형태나 수단으로 이 전자책과 책의 내용을 이용할 수 없으며, 이 전자책은 저작권법에 의해 보호받는 저작물이므로 무단전재 또는 무단복제 할 경우 법적 책임을 질 수 있습니다.</span>
            </li>
          </div>
          <div>
            <b>워터마크 위치 선택</b>
            <div class="radioListButton">
              <div v-for="(item, index) in colorList" :key="index">
                <input type="radio" name="color" :id="'cp' + index" :checked="item.checked" :value="item.value" @change="colorChange"/>
                <label :for="'cp' + index">{{ item.text }}</label>
              </div>
            </div>
            <div class="radioListButton">
              <div v-for="(item, index) in positionList" :key="index">
                <input type="radio" name="position" :id="'csp' + index" :checked="item.checked" :value="item.value" @change="positionChange"/>
                <label :for="'csp' + index">{{ item.text }}</label>
              </div>
            </div>
            <div class="radioListButton">
              <div v-for="(item, index) in opacityList" :key="index">
                <input type="radio" name="opacity" :id="'cso' + index" :checked="item.checked" :value="item.value" @change="opacityChange"/>
                <label :for="'cso' + index">{{ item.text }}</label>
              </div>
            </div>
          </div>
          <li>
            <div>
              <span>파일명</span>
            </div>
            <div>
              <UInput type="text" line="bottom" v-model="filename"/>
            </div>
          </li>
        </div>
      </div>
    </template>
  </AbsPopup>
</template>

<script>
import AbsPopup from '@/components/popup/AbsPopup.vue'
import UInput from '@/components/base/UInput.vue'
import Epub from '@/components/js/Epub.js'
import {timeToDateString} from '@/components/js/Utils'
import FileServer from 'file-saver'
var epub = new Epub()

export default {
  props: {
    option: {
      type: Object
    }
  },
  watch: {
  },
  created () {
  },
  mounted () {
    this.$emit('loading', true)
    if (this.option.param) {
      this.$http.post('/api/admin/publishing/epub', {epub: this.option.param.id}).then((s) => {
        console.log('epub', s)
        if (s.success) {
          this.epub = s
          this.cover = s.cover
          this.title = epub.title = s.name
          this.name = epub.creator = s.contract.nic
          this.date = this.getStoreConfirm
          this.publisher = epub.publisher = '스담'
          this.addr = epub.addr = '서울시 관악구 남부순환로 1861, 덕수빌딩 2층'
          this.email = epub.email = 'biz@tmeka.com'
          // epub.date = timeToDateString(this.getStoreConfirm)
          epub.isEpubInfo = true
          if (s.isbn) {
            this.isbn = epub.isbn = s.isbn.replace(/(^\d{3})(\d{2})(\d{5})(\d{2})(\d{1})$/g, '$1-$2-$3-$4-$5')
          }
          this.color = s.watermarkColor ? s.watermarkColor : this.color
          this.position = s.watermarkPosition ? s.watermarkPosition : this.position
          this.opacity = s.watermarkOpacity ? s.watermarkOpacity : this.opacity
          this.colorList.forEach(item => {
            item.checked = (item.value === this.color) ? 'checked' : null
          })
          this.positionList.forEach(item => {
            item.checked = (item.value === this.position) ? 'checked' : null
          })
          this.opacityList.forEach(item => {
            item.checked = (item.value === this.opacity) ? 'checked' : null
          })
          this.filename = s.file
          this.getImageSize()
          this.$emit('loading', false)
        }
      })
    }
  },
  data () {
    return {
      timeToDateString: timeToDateString,
      epub: null,
      cover: null,
      title: '',
      name: '',
      date: '',
      publisher: '',
      addr: '',
      email: '',
      isbn: '',
      color: 'mark-w',
      colorList: [
        {text: '흰색', value: 'mark-w', checked: 'checked'},
        {text: '검은색', value: 'mark-b'}
      ],
      position: 'left bottom',
      positionList: [
        {text: '왼쪽 상단', value: 'left top'},
        {text: '오른쪽 상단', value: 'right top'},
        {text: '왼쪽 하단', value: 'left bottom', checked: 'checked'},
        {text: '오른쪽 하단', value: 'right bottom'}
      ],
      opacity: 'op2',
      opacityList: [
        {text: '100%', value: 'op1'},
        {text: '80%', value: 'op2', checked: 'checked'},
        {text: '60%', value: 'op3'},
        {text: '40%', value: 'op4'}
      ],
      filename: '',
      size: '',
      canvasImg: ''
    }
  },
  name: 'CreateEpub',
  computed: {
    getStoreConfirm () {
      var date = null
      var item = this.epub.publication
      item.store.forEach((item, index) => {
        console.log('getStoreConfirm', date, item.confirm)
        if (date && item.confirm && date > item.confirm) {
          date = item.confirm
        } else if (date === null && item.confirm) {
          date = item.confirm
        }
      })
      return date
    },
    markColor () {
      var item = this.colorList.find((item) => item.checked !== null)
      console.log(item)
      return item.value
    },
    markPosition () {
      return 'left top'
    }
  },
  methods: {
    getImageSize () {
      if (this.cover) {
        var im = new Image()
        im.onload = () => {
          console.log('getImageSize onload complete', im.complete)
          this.size = im.width + ' * ' + im.height
        }
        im.src = this.cover
      }
    },
    setCanvas (im, cb) {
      console.log('setCanvas', im)
      // let pw = 1200
      // let ph = 1788
      var c = document.createElement('canvas')
      c.width = im.width
      c.height = im.height
      c.getContext('2d').drawImage(im, 0, 0, im.width, im.height)
      this.canvasImg = c.toDataURL('image/jpeg')
      epub.cover = this.canvasImg
      epub.coverName = 'COVER'
      cb()
      // html2canvas(im, {scale: 2, useCORS: true}).then(c => {
      //   console.log('canvas', c)
      //   this.canvasImg = c.toDataURL('image/jpeg')
      //   epub.cover = this.canvasImg
      //   epub.coverName = 'COVER'
      //   cb()
      // })
    },
    colorChange () {
      this.color = document.querySelector('input[name=color]:checked').value
    },
    positionChange () {
      this.position = document.querySelector('input[name=position]:checked').value
    },
    opacityChange () {
      this.opacity = document.querySelector('input[name=opacity]:checked').value
    },
    changeImage (im) {
      return new Promise((resolve, reject) => {
        var i = new Image()
        i.onload = () => {
          var c = document.createElement('canvas')
          c.width = i.width
          c.height = i.height
          c.getContext('2d').drawImage(i, 0, 0, i.width, i.height)
          im.src = c.toDataURL('image/jpeg')
          console.log(c)
          resolve(i.src)
        }
        i.error = (er) => {
          reject(er)
        }
        i.src = im.src
      })
    },
    submit () {
      this.$emit('loading', true)
      this.$http.post('/api/admin/publishing/epubInfo', {
        epub: this.option.param.id,
        isbn: this.isbn.replace(/-/g, ''),
        color: this.color,
        position: this.position,
        opacity: this.opacity,
        file: this.filename
      }).then((s) => {
        if (s.success) {
          this.setCanvas(document.querySelector('.cover div img'), () => {
            var footnote = []
            var indexList = []
            var secList = []
            var img = []
            this.epub.postList.forEach((item, index) => {
              footnote.push(item.footnote)
              console.log('footnote', item.footnote, footnote)
              var k = document.createDocumentFragment()
              var h = document.createElement('h2')
              h.id = Epub.INDEX + index
              h.class = 'left'
              h.innerText = item.subtitle
              k.appendChild(h)
              k.appendChild(document.createElement('p'))
              k.appendChild(document.createElement('p'))
              var d = document.createElement('div')
              d.innerHTML = item.body
              var rss = [...new Set(d.childNodes)]
              rss.forEach((n) => {
                k.appendChild(n)
              })
              item.footnote.forEach((item) => {
                item.href = item.id.replace(/ufnv/gim, '#ufn')
              })
              indexList.push({name: item.subtitle, id: h.id})
              // k.querySelectorAll('img').reduce((prev, bitem) => {
              //   return prev.then((k) => {
              //     if (k) {
              //       img.push(k)
              //     }
              //     return this.changeImage(bitem)
              //   })
              // }, Promise.resolve()).then(p => {
              //   if (p) {
              //     img.push(p)
              //   }
              // })
              k.querySelectorAll('img').forEach((im, idx) => {
                img.push(this.changeImage(im))
              })
              console.log(k)
              console.log(k.querySelectorAll('p'))
              secList.push(k)
            })
            epub.footnotelist = footnote
            epub.indexList = indexList
            epub.sectionList = secList
            epub.isbn = this.isbn
            // img.reduce((prev, imgitem) => {
            //   return prev.then((k) => {
            //     return this.changeImage(bitem)
            //   })
            // }, Promise.resolve())
            Promise.all(img).then((imgar) => {
              console.log(imgar)
              epub.create((f) => {
                this.$emit('loading', false)
                FileServer.saveAs(f, this.filename + '.epub')
              })
            })
          })
        }
      })
    }
  },
  components: {
    AbsPopup,
    UInput
  }
}
</script>

<style scoped>
#CreateEpub {
  padding: 10px 0;
  width: 1100px;
}
.popup-body {
  display: flex;
  flex-direction: row;
  line-height: 30px;
  width: 100%;
  padding: 10px;
}
/* 1200 1788 */
.popup-body .cover img {
  width: 1200px;
}
.popup-body > div {
  display: flex;
  flex-direction: column;
  list-style: none;
}
.popup-body > div:first-child {
  margin-right: 10px;
  padding-right: 10px;
  border-right: 1px solid var(--line-base);
}
.popup-body > div > div > li {
  display: flex;
  flex-direction: row;
}
.popup-body > div > div > li > div:first-child {
  width:  120px;
  text-align: right;
  padding-right: 10px;
}
.popup-body > div > div > li > div:last-child {
  flex: 1;
}
.popup-body .input {
  height: 100%;
}
.popup-body > div > div > li:last-child {
  border-top: 1px solid var(--line-guide);
}
.popup-body > div > span:last-child {
  border-top: 1px solid var(--line-base);
}

.radioListButton {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.radioListButton > div {
  display: flex;
  min-width: 48%;
}
.radioListButton > div:nth-child(1n) {
  margin-left: 10px;
  margin-bottom: 10px;
}
.radioListButton > div:nth-child(2n+1) {
  margin-left: 0px;
}
.radioListButton input {
  display: none;
}
.radioListButton input + label {
  position: relative;
  width: 100%;
  height: 100%;
  border: 1px solid var(--line-base);
  color: var(--line-base);
  text-align: center;
  cursor: pointer;
}
.radioListButton input:checked + label {
  background-color: var(--line-title);
  color: var(--bg-white);
}
.radioListButton input:checked + label::after {
  position: absolute;
  content: '\2714';
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
}
.popup-body .cover > div > img {
  width: 600px;
  /* width: 100px; */
}
.popup-body .cover > div {
  position: relative;
}
.popup-body .cover > div .absMark {
  position: absolute;
  font-size: 50px;
}
.absMark {
  position: absolute;
  font-size: 50px;
}
.absMark.mark-w {
  color: #FFFFFF;
}
.absMark.mark-b {
  color: #000000;
}
.absMark.left {
  left: 15px;
}
.absMark.right {
  right: 35px;
}
.absMark.top {
  top: 20px;
}
.absMark.bottom {
  bottom: 50px;
}
.absMark.op1 {
  opacity: 1;
}
.absMark.op2 {
  opacity: 0.8;
}
.absMark.op3 {
  opacity: 0.6;
}
.absMark.op4 {
  opacity: 0.4;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/admin/CreateEpub.vue